import * as React from 'react'
import { createSvgIcon } from '@mui/material/utils'
import { ReactComponent as AlertIcon } from '../../../assets/icons/alerts.svg'
import { ReactComponent as ActivateIcon } from '../../../assets/icons/activ.svg'
import { ReactComponent as ManagementIcon } from '../../../assets/icons/managment.svg'
import { ReactComponent as ClinicIcon } from '../../../assets/icons/clinicDash.svg'
import { ReactComponent as OrganizationIcon } from '../../../assets/icons/organization.svg'
import { ReactComponent as HelpIcon } from '../../../assets/icons/Help.svg'
import { ReactComponent as MyPersonalIcon } from '../../../assets/icons/MyPersonal.svg'
import { ReactComponent as SignUpIcon } from '../../../assets/icons/SignUp.svg'
import { ReactComponent as CheckBoxIcon } from '../../../assets/icons/checkBox.svg'
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg'
import { ReactComponent as SendMessageIcon } from '../../../assets/table/sendMessage.svg'
import { ReactComponent as SendArticleIcon } from '../../../assets/table/sendArticle.svg'

import { ReactComponent as CheckCheckbox } from '../../../assets/icons/checked_checkbox.svg'
import { ReactComponent as SelectCheckbox } from '../../../assets/icons/select.svg'

import { ReactComponent as ArrowLeft } from '../../../assets/icons/Union 11.svg'

import { ReactComponent as CloseBulk } from '../../../assets/icons/X_icon.svg'
import { ReactComponent as ChatBulk } from '../../../assets/bulk/Chat.svg'

import { ReactComponent as BtnPoint } from '../../../assets/bulk/btnPoint.svg'

import { ReactComponent as FullHeart } from '../../../assets/bulk/fullHeart.svg'
import { ReactComponent as Heart } from '../../../assets/bulk/heart.svg'
import { ReactComponent as DeleteTemplate } from '../../../assets/bulk/Delete icon.svg'
import { ReactComponent as EditTemplate } from '../../../assets/bulk/edit.svg'
import { ReactComponent as SaveFull } from '../../../assets/bulk/saveFull.svg'
import { ReactComponent as SaveGray } from '../../../assets/bulk/saveGray.svg'
import { ReactComponent as Cvik } from '../../../assets/chat/cvik.svg'
import { ReactComponent as CvikOn } from '../../../assets/chat/cvik-on.svg'
import { ReactComponent as Send } from '../../../assets/chat/send.svg'
import { ReactComponent as AddCnt } from '../../../assets/chat/add-cnt.svg'
import { ReactComponent as Online } from '../../../assets/chat/online.svg'
import { ReactComponent as Task } from '../../../assets/notofocations/task.svg'
import { ReactComponent as Alert } from '../../../assets/notofocations/alert.svg'
import { ReactComponent as Calendar } from '../../../assets/notofocations/calendar.svg'
import { ReactComponent as Chat } from '../../../assets/notofocations/chat.svg'
import { ReactComponent as AlertClose } from '../../../assets/notofocations/X_icon.svg'
import HeartFull from '../../../assets/bulk/fullheart.png'

import { ReactComponent as DateRange } from '../../../assets/charts/dateRange.svg'
import { ReactComponent as Reload } from '../../../assets/charts/reload.svg'

export const AvaIcon = createSvgIcon(
	<g data-name='Group 4793'>
		<g stroke={'#fff'} strokeWidth={'2px'} fill={'none'}>
			<circle cx='16' cy='16' r='16' />
			<circle cx='16' cy='16' r='15' />
		</g>
		<path
			data-name='Path 6596'
			d='M3.7 1.589h8.89a2.253 2.253 0 0 0 1.436-.341 1.168 1.168 0 0 0 .4-.934 2.906 2.906 0 0 0-.443-1.458 5.292 5.292 0 0 0-1.271-1.432 6.779 6.779 0 0 0-1.985-1.088 7.554 7.554 0 0 0-2.582-.416 7.554 7.554 0 0 0-2.578.417 6.779 6.779 0 0 0-1.985 1.089 5.292 5.292 0 0 0-1.271 1.431A2.906 2.906 0 0 0 1.868.315a1.168 1.168 0 0 0 .4.934 2.253 2.253 0 0 0 1.432.34zm4.445-6.921a2.778 2.778 0 0 0 1.545-.447 3.237 3.237 0 0 0 1.095-1.2 3.457 3.457 0 0 0 .406-1.674 3.3 3.3 0 0 0-.41-1.626 3.292 3.292 0 0 0-1.1-1.187 2.765 2.765 0 0 0-1.538-.447 2.77 2.77 0 0 0-1.534.447 3.272 3.272 0 0 0-1.1 1.19 3.26 3.26 0 0 0-.4 1.63 3.442 3.442 0 0 0 .406 1.666 3.237 3.237 0 0 0 1.095 1.2 2.765 2.765 0 0 0 1.535.448z'
			transform='translate(8 21)'
		/>
	</g>,
	'AvaIcon'
)

export const AlertSvg = <AlertIcon />
export const ActivateSvg = <ActivateIcon />
export const ManagementSvg = <ManagementIcon />
export const ClinicSvg = <ClinicIcon />
export const OrganizationSvg = <OrganizationIcon />
export const HelpSvg = <HelpIcon />
export const MyPersonalSvg = <MyPersonalIcon />
export const SignUpSvg = <SignUpIcon />
export const CheckBoxSvg = <CheckBoxIcon />
export const CloseSvg = <CloseIcon />
export const SendMessageSvg = <SendMessageIcon />
export const SendArticleSvg = <SendArticleIcon />

export const CheckCheckboxSvg = <CheckCheckbox />
export const SelectCheckboxSvg = <SelectCheckbox />

export const ArrowLeftSvg = <ArrowLeft />
export const CloseBulkSvg = <CloseBulk />
export const ChatBulkSvg = <ChatBulk />
export const BtnPointSvg = <BtnPoint />
export const FullHeartSvg = <FullHeart />
export const HeartSvg = <Heart />

export const HeartPng = HeartFull

export const DeleteTemplateSvg = <DeleteTemplate />
export const EditTemplateSvg = <EditTemplate />

export const SaveFullSvg = <SaveFull />
export const SaveGraySvg = <SaveGray />

export const DateRangeSvg = <DateRange />
export const ReloadSvg = <Reload />
export const CvikSvg = <Cvik />
export const CvikOnSvg = <CvikOn />
export const SendSvg = <Send />
export const AddCntSvg = <AddCnt />
export const OnlineSvg = <Online />
export const TaskSvg = <Task />
export const AlertSvgNotific = <Alert />
export const SvgAlert = <Alert />
export const CalendarSvg = <Calendar />
export const SvgChat = <Chat />
export const AlertCloseSvg = <AlertClose />
